/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseDbAccountReportListOSICoreTypes,
  ApiResponseDbAccountReportOSICoreTypes,
  ApiResponseIEnumerable1OSICoreModelsDbAccountReportPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsRequestsAccountReportUpdateListDetailsItemPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsResponsesAccountReportCategoryResponsePrivateCoreLib,
  ApiResponseResponsesAccountReportFormDataOSICoreTypes,
  ApiResponseResponsesAccountReportStatusResponseOSICoreTypes,
  RequestsAccountReportPublishRequest,
  RequestsAccountReportRequest,
  RequestsAccountReportUpdateListDetailsItem,
  RequestsCleanReportsRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить ежемесячные отчеты
 */
export const getApiAccountReportsOsiOsiId = (
  osiId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbAccountReportPrivateCoreLib>(
    { url: `/api/AccountReports/osi/${osiId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAccountReportsOsiOsiIdQueryKey = (osiId: number) => {
  return [`/api/AccountReports/osi/${osiId}`] as const;
};

export const getGetApiAccountReportsOsiOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAccountReportsOsiOsiIdQueryKey(osiId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>> = ({ signal }) =>
    getApiAccountReportsOsiOsiId(osiId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAccountReportsOsiOsiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>
>;
export type GetApiAccountReportsOsiOsiIdQueryError = ErrorType<unknown>;

export function useGetApiAccountReportsOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить ежемесячные отчеты
 */

export function useGetApiAccountReportsOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAccountReportsOsiOsiIdQueryOptions(osiId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить ежегодные отчеты
 */
export const getApiAccountReportsOsiOsiIdAnnual = (
  osiId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbAccountReportPrivateCoreLib>(
    { url: `/api/AccountReports/osi/${osiId}/annual`, method: 'GET', signal },
    options
  );
};

export const getGetApiAccountReportsOsiOsiIdAnnualQueryKey = (osiId: number) => {
  return [`/api/AccountReports/osi/${osiId}/annual`] as const;
};

export const getGetApiAccountReportsOsiOsiIdAnnualQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAccountReportsOsiOsiIdAnnualQueryKey(osiId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>> = ({ signal }) =>
    getApiAccountReportsOsiOsiIdAnnual(osiId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAccountReportsOsiOsiIdAnnualQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>
>;
export type GetApiAccountReportsOsiOsiIdAnnualQueryError = ErrorType<unknown>;

export function useGetApiAccountReportsOsiOsiIdAnnual<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsOsiOsiIdAnnual<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsOsiOsiIdAnnual<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить ежегодные отчеты
 */

export function useGetApiAccountReportsOsiOsiIdAnnual<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdAnnual>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAccountReportsOsiOsiIdAnnualQueryOptions(osiId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить статус по отчету прошлого месяца
 */
export const getApiAccountReportsOsiOsiIdPrevMonthStatus = (
  osiId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesAccountReportStatusResponseOSICoreTypes>(
    { url: `/api/AccountReports/osi/${osiId}/prev-month-status`, method: 'GET', signal },
    options
  );
};

export const getGetApiAccountReportsOsiOsiIdPrevMonthStatusQueryKey = (osiId: number) => {
  return [`/api/AccountReports/osi/${osiId}/prev-month-status`] as const;
};

export const getGetApiAccountReportsOsiOsiIdPrevMonthStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAccountReportsOsiOsiIdPrevMonthStatusQueryKey(osiId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>> = ({
    signal
  }) => getApiAccountReportsOsiOsiIdPrevMonthStatus(osiId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAccountReportsOsiOsiIdPrevMonthStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>
>;
export type GetApiAccountReportsOsiOsiIdPrevMonthStatusQueryError = ErrorType<unknown>;

export function useGetApiAccountReportsOsiOsiIdPrevMonthStatus<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsOsiOsiIdPrevMonthStatus<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsOsiOsiIdPrevMonthStatus<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить статус по отчету прошлого месяца
 */

export function useGetApiAccountReportsOsiOsiIdPrevMonthStatus<
  TData = Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsOsiOsiIdPrevMonthStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAccountReportsOsiOsiIdPrevMonthStatusQueryOptions(osiId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Создать отчет
 */
export const postApiAccountReports = (
  requestsAccountReportRequest: BodyType<RequestsAccountReportRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbAccountReportOSICoreTypes>(
    {
      url: `/api/AccountReports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAccountReportRequest,
      signal
    },
    options
  );
};

export const getPostApiAccountReportsMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAccountReports>>,
    TError,
    { data: BodyType<RequestsAccountReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAccountReports>>,
  TError,
  { data: BodyType<RequestsAccountReportRequest> },
  TContext
> => {
  const mutationKey = ['postApiAccountReports'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAccountReports>>,
    { data: BodyType<RequestsAccountReportRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiAccountReports(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAccountReportsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAccountReports>>>;
export type PostApiAccountReportsMutationBody = BodyType<RequestsAccountReportRequest>;
export type PostApiAccountReportsMutationError = ErrorType<unknown>;

/**
 * @summary Создать отчет
 */
export const usePostApiAccountReports = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAccountReports>>,
      TError,
      { data: BodyType<RequestsAccountReportRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAccountReports>>,
  TError,
  { data: BodyType<RequestsAccountReportRequest> },
  TContext
> => {
  const mutationOptions = getPostApiAccountReportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Прикрепить выписку по счету
 */
export const putApiAccountReportsListListId = (
  listId: number,
  putApiAccountReportsListListIdBody: BodyType<string>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/AccountReports/list/${listId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/octet-stream' },
      data: putApiAccountReportsListListIdBody
    },
    options
  );
};

export const getPutApiAccountReportsListListIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAccountReportsListListId>>,
    TError,
    { listId: number; data: BodyType<string> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiAccountReportsListListId>>,
  TError,
  { listId: number; data: BodyType<string> },
  TContext
> => {
  const mutationKey = ['putApiAccountReportsListListId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiAccountReportsListListId>>,
    { listId: number; data: BodyType<string> }
  > = (props) => {
    const { listId, data } = props ?? {};

    return putApiAccountReportsListListId(listId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiAccountReportsListListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiAccountReportsListListId>>
>;
export type PutApiAccountReportsListListIdMutationBody = BodyType<string>;
export type PutApiAccountReportsListListIdMutationError = ErrorType<unknown>;

/**
 * @summary Прикрепить выписку по счету
 */
export const usePutApiAccountReportsListListId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiAccountReportsListListId>>,
      TError,
      { listId: number; data: BodyType<string> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiAccountReportsListListId>>,
  TError,
  { listId: number; data: BodyType<string> },
  TContext
> => {
  const mutationOptions = getPutApiAccountReportsListListIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получить список по счету
 */
export const getApiAccountReportsListListId = (
  listId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbAccountReportListOSICoreTypes>(
    { url: `/api/AccountReports/list/${listId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAccountReportsListListIdQueryKey = (listId: number) => {
  return [`/api/AccountReports/list/${listId}`] as const;
};

export const getGetApiAccountReportsListListIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
  TError = ErrorType<unknown>
>(
  listId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsListListId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAccountReportsListListIdQueryKey(listId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAccountReportsListListId>>> = ({ signal }) =>
    getApiAccountReportsListListId(listId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!listId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAccountReportsListListIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAccountReportsListListId>>
>;
export type GetApiAccountReportsListListIdQueryError = ErrorType<unknown>;

export function useGetApiAccountReportsListListId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
  TError = ErrorType<unknown>
>(
  listId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsListListId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsListListId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsListListId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
  TError = ErrorType<unknown>
>(
  listId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsListListId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsListListId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsListListId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
  TError = ErrorType<unknown>
>(
  listId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsListListId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить список по счету
 */

export function useGetApiAccountReportsListListId<
  TData = Awaited<ReturnType<typeof getApiAccountReportsListListId>>,
  TError = ErrorType<unknown>
>(
  listId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsListListId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAccountReportsListListIdQueryOptions(listId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Обновить данные по комментариям
 */
export const postApiAccountReportsListListIdDetails = (
  listId: number,
  requestsAccountReportUpdateListDetailsItem: BodyType<RequestsAccountReportUpdateListDetailsItem[]>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsRequestsAccountReportUpdateListDetailsItemPrivateCoreLib>(
    {
      url: `/api/AccountReports/list/${listId}/details`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAccountReportUpdateListDetailsItem,
      signal
    },
    options
  );
};

export const getPostApiAccountReportsListListIdDetailsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAccountReportsListListIdDetails>>,
    TError,
    { listId: number; data: BodyType<RequestsAccountReportUpdateListDetailsItem[]> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAccountReportsListListIdDetails>>,
  TError,
  { listId: number; data: BodyType<RequestsAccountReportUpdateListDetailsItem[]> },
  TContext
> => {
  const mutationKey = ['postApiAccountReportsListListIdDetails'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAccountReportsListListIdDetails>>,
    { listId: number; data: BodyType<RequestsAccountReportUpdateListDetailsItem[]> }
  > = (props) => {
    const { listId, data } = props ?? {};

    return postApiAccountReportsListListIdDetails(listId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAccountReportsListListIdDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAccountReportsListListIdDetails>>
>;
export type PostApiAccountReportsListListIdDetailsMutationBody = BodyType<RequestsAccountReportUpdateListDetailsItem[]>;
export type PostApiAccountReportsListListIdDetailsMutationError = ErrorType<unknown>;

/**
 * @summary Обновить данные по комментариям
 */
export const usePostApiAccountReportsListListIdDetails = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAccountReportsListListIdDetails>>,
      TError,
      { listId: number; data: BodyType<RequestsAccountReportUpdateListDetailsItem[]> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAccountReportsListListIdDetails>>,
  TError,
  { listId: number; data: BodyType<RequestsAccountReportUpdateListDetailsItem[]> },
  TContext
> => {
  const mutationOptions = getPostApiAccountReportsListListIdDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Опубликовать отчет
 */
export const putApiAccountReportsId = (
  id: number,
  requestsAccountReportPublishRequest: BodyType<RequestsAccountReportPublishRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/AccountReports/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAccountReportPublishRequest
    },
    options
  );
};

export const getPutApiAccountReportsIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAccountReportsId>>,
    TError,
    { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiAccountReportsId>>,
  TError,
  { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
  TContext
> => {
  const mutationKey = ['putApiAccountReportsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiAccountReportsId>>,
    { id: number; data: BodyType<RequestsAccountReportPublishRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiAccountReportsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiAccountReportsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAccountReportsId>>>;
export type PutApiAccountReportsIdMutationBody = BodyType<RequestsAccountReportPublishRequest>;
export type PutApiAccountReportsIdMutationError = ErrorType<unknown>;

/**
 * @summary Опубликовать отчет
 */
export const usePutApiAccountReportsId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiAccountReportsId>>,
      TError,
      { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiAccountReportsId>>,
  TError,
  { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
  TContext
> => {
  const mutationOptions = getPutApiAccountReportsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получить список категорий для выбора
 */
export const getApiAccountReportsCategories = (
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsResponsesAccountReportCategoryResponsePrivateCoreLib>(
    { url: `/api/AccountReports/categories`, method: 'GET', signal },
    options
  );
};

export const getGetApiAccountReportsCategoriesQueryKey = () => {
  return [`/api/AccountReports/categories`] as const;
};

export const getGetApiAccountReportsCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsCategories>>, TError, TData>>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAccountReportsCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAccountReportsCategories>>> = ({ signal }) =>
    getApiAccountReportsCategories(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAccountReportsCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAccountReportsCategories>>
>;
export type GetApiAccountReportsCategoriesQueryError = ErrorType<unknown>;

export function useGetApiAccountReportsCategories<
  TData = Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsCategories<
  TData = Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsCategories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountReportsCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountReportsCategories<
  TData = Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsCategories>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить список категорий для выбора
 */

export function useGetApiAccountReportsCategories<
  TData = Awaited<ReturnType<typeof getApiAccountReportsCategories>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountReportsCategories>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAccountReportsCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить данные для формирования ежемесячного отчета
 */
export const postApiAccountReportsIdMonthlyFormData = (
  id: number,
  requestsAccountReportPublishRequest: BodyType<RequestsAccountReportPublishRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesAccountReportFormDataOSICoreTypes>(
    {
      url: `/api/AccountReports/${id}/monthly-form-data`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAccountReportPublishRequest,
      signal
    },
    options
  );
};

export const getPostApiAccountReportsIdMonthlyFormDataMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAccountReportsIdMonthlyFormData>>,
    TError,
    { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAccountReportsIdMonthlyFormData>>,
  TError,
  { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
  TContext
> => {
  const mutationKey = ['postApiAccountReportsIdMonthlyFormData'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAccountReportsIdMonthlyFormData>>,
    { id: number; data: BodyType<RequestsAccountReportPublishRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiAccountReportsIdMonthlyFormData(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAccountReportsIdMonthlyFormDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAccountReportsIdMonthlyFormData>>
>;
export type PostApiAccountReportsIdMonthlyFormDataMutationBody = BodyType<RequestsAccountReportPublishRequest>;
export type PostApiAccountReportsIdMonthlyFormDataMutationError = ErrorType<unknown>;

/**
 * @summary Получить данные для формирования ежемесячного отчета
 */
export const usePostApiAccountReportsIdMonthlyFormData = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAccountReportsIdMonthlyFormData>>,
      TError,
      { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAccountReportsIdMonthlyFormData>>,
  TError,
  { id: number; data: BodyType<RequestsAccountReportPublishRequest> },
  TContext
> => {
  const mutationOptions = getPostApiAccountReportsIdMonthlyFormDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Очистка отчетов ОСИ
 */
export const postApiAccountReportsCleanReports = (
  requestsCleanReportsRequest: BodyType<RequestsCleanReportsRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/AccountReports/clean-reports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsCleanReportsRequest,
      signal
    },
    options
  );
};

export const getPostApiAccountReportsCleanReportsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAccountReportsCleanReports>>,
    TError,
    { data: BodyType<RequestsCleanReportsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAccountReportsCleanReports>>,
  TError,
  { data: BodyType<RequestsCleanReportsRequest> },
  TContext
> => {
  const mutationKey = ['postApiAccountReportsCleanReports'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAccountReportsCleanReports>>,
    { data: BodyType<RequestsCleanReportsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiAccountReportsCleanReports(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAccountReportsCleanReportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAccountReportsCleanReports>>
>;
export type PostApiAccountReportsCleanReportsMutationBody = BodyType<RequestsCleanReportsRequest>;
export type PostApiAccountReportsCleanReportsMutationError = ErrorType<unknown>;

/**
 * @summary Очистка отчетов ОСИ
 */
export const usePostApiAccountReportsCleanReports = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAccountReportsCleanReports>>,
      TError,
      { data: BodyType<RequestsCleanReportsRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAccountReportsCleanReports>>,
  TError,
  { data: BodyType<RequestsCleanReportsRequest> },
  TContext
> => {
  const mutationOptions = getPostApiAccountReportsCleanReportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
